<stx-checkbox-group-filter
  [dictionaryOptions]="dictionaryOptions"
  [filterName]="'ageGroups'"
  [formGroupReference]="formGroupReference"
  [legendTranslationNode]="'reports.filters.nutrition_management.age_group.group_label'"
  (filterChange)="reportService.onFilterChange($event)"
>
</stx-checkbox-group-filter>
